import { Socials } from './constants';

export const config = {
    daoPerformanceFees: 10,
    ethereumSpoolAddresses: {
        spoolToken: '0x40803cea2b2a32bda1be61d3604af6a814e70976',
        staking: '0xc3160c5cc63b6116dd182faa8393d3ad9313e213',
        controller: '0xdd4051c3571c143b989c3227e8eb50983974835c',
        'SPOOL-DAI-LP': '0xf3b675df63fb4889180d290a338fc15c0766fd64',
    },
    arbitrumSpoolAddresses: {
        spoolToken: '0xe4b6347395262d203e3fec5c8ebde4cfe92111b3',
        staking: '0x0000000000000000000000000000000000000000',
        controller: '0xd31ff4536bd190c87039c7697b3a5843196c1b94',
        'SPOOL-DAI-LP': '0x0000000000000000000000000000000000000000',
    },
    snapshot: {
        SNAPSHOT_HUB_PRODUCTION: 'https://hub.snapshot.org',
        //For Gnosis Safe Votes
        SNAPSHOT_HUB_RELAYER: 'https://relayer.snapshot.org',
        SNAPSHOT_HUB_STAGING: 'https://testnet.snapshot.org',
        SNAPSHOT_SPACE: 'egov.spool.eth',
        SNAPSHOT_VOTE_TYPE: 'weighted',
        SNAPSHOT_PERSONAL_SIGN_VOTE_TYPE: 'vote',
        PROPOSAL_ID: undefined,
    },
    socialMedias: {
        [Socials.DISCORD]: 'https://discord.gg/kCDC7BWxrw',
        [Socials.TELEGRAM]: 'https://t.me/SpoolFi',
        [Socials.TWITTER]: 'https://twitter.com/spoolfi',
        [Socials.MEDIUM]: 'https://medium.com/spoolfi',
        [Socials.LINKEDIN]: 'https://www.linkedin.com/company/spooldao/',
        [Socials.GITBOOK]: 'https://docs.spool.fi/',
    },
    urls: {
        spoolApp: 'https://app.spool.fi',
        spoolVault: 'https://vault.spool.fi',
        etherscan: 'https://etherscan.io',
        arbiscan: 'https://arbiscan.io',
        sdk: 'https://www.npmjs.com/package/@spool.fi/spool-sdk',
        spoolPath: 'app/spool', // used for routing and when users copy individual URLs to share
    },
    smartContract: {
        vesting: '0x08772c1872c997Fec8dA3c7f36C1FC28EBE72E97',
        builderVesting: '0x2CF74CAE19D188a4E5870de705F67a48c7324Bc7',
    },
};

export const SDK_CONFIG_ETHEREUM = {
    analytics: {
        ANALYTICS_API_BASE_URL: 'https://analytics.spool.fi/',
    },
    priceFeed: {
        PRICE_FEED_API_BASE_URL: 'https://pricefeed.spool.fi/',
    },
    subgraph: {
        // SUBGRAPH_API_BASE_URL:
        //     'https://gateway.thegraph.com/api/7ddb936ea81570e53e3b86984006a0ba/subgraphs/id/7Q3AhbW58FcPnyMS5DW7sxdi4MQxSFRDCvDsntLxy24H',
        SUBGRAPH_API_BASE_URL: 'https://api.thegraph.com/subgraphs/name/spoolfi/spool',
        UNISWAP_SUBGRAPH_API_BASE_URL:
            'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
        SNAPSHOT_SUBGRAPH_API_BASE_URL: 'https://hub.snapshot.org/graphql',
        SNAPSHOT_SPACE: 'egov.spool.eth',
        default_limit: 100,
    },
    smartContracts: {
        controller: '0xdd4051c3571c143b989c3227e8eb50983974835c',
        'SPOOL-ERC20': '0x40803cea2b2a32bda1be61d3604af6a814e70976',
        'SPOOL-DAI-LP': '0xf3b675df63fb4889180d290a338fc15c0766fd64',
        spoolStaking: '0xc3160c5cc63b6116dd182faa8393d3ad9313e213',
        voSpool: '0xaf56d16a7fe479f2fcd48ff567ff589cb2d2a0e9',
        voSpoolRewards: '0xb8d5fc11f8e1af30578db9f77174a1dc171a7d28',
        multicallv2: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        feeHandler: '0x3d3d0a7876d18770a21a5ea05fef211eba808e72',
    },
};

export const SDK_CONFIG_ARBITRUM = {
    analytics: {
        ANALYTICS_API_BASE_URL:
            'https://analytics-preprod-webapi.1epl1di4e824g.eu-west-2.cs.amazonlightsail.com/arbitrum',
    },
    subgraph: {
        SUBGRAPH_API_BASE_URL:
            'https://api.thegraph.com/subgraphs/name/spoolfi/spool-arbitrum',
        UNISWAP_SUBGRAPH_API_BASE_URL:
            'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
        SNAPSHOT_SUBGRAPH_API_BASE_URL: 'https://hub.snapshot.org/graphql',
        SNAPSHOT_SPACE: 'spool.eth',
        default_limit: 100,
    },
    smartContracts: {
        spool: '0xe4b6347395262d203e3fec5c8ebde4cfe92111b3',
        controller: '0xd31ff4536bd190c87039c7697b3a5843196c1b94',
        'SPOOL-ERC20': '0x0000000000000000000000000000000000000000',
        'SPOOL-DAI-LP': '0x0000000000000000000000000000000000000000',
        spoolStaking: '0x0000000000000000000000000000000000000000',
        voSpool: '0x0000000000000000000000000000000000000000',
        voSpoolRewards: '0x0000000000000000000000000000000000000000',
        multicallv2: '0x842eC2c7D803033Edf55E478F461FC547Bc54EB2',
        feeHandler: '0xbbb0e84f4e3d4ffacd3bd4241136b8b53a0b5bba',
    },
};

export const SDK_CONFIG_DEVELOPMENT = {
    analytics: {
        ANALYTICS_API_BASE_URL: 'https://spoolanalytics-dev.solidant.io',
    },
    subgraph: {
        SUBGRAPH_API_BASE_URL:
            'https://subgraph.spool-test.solidant.io/subgraphs/name/spool/subgraph',
        UNISWAP_SUBGRAPH_API_BASE_URL:
            'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
        SNAPSHOT_SUBGRAPH_API_BASE_URL: 'https://testnet.snapshot.org/graphql',
        SNAPSHOT_SPACE: 'daddy.test',
        default_limit: 100,
    },
    smartContracts: {
        controller: '0xdd4051c3571c143b989c3227e8eb50983974835c',
        'SPOOL-ERC20': '0x40803cea2b2a32bda1be61d3604af6a814e70976',
        'SPOOL-DAI-LP': '0xf3b675df63fb4889180d290a338fc15c0766fd64',
        spoolStaking: '0xc3160c5cc63b6116dd182faa8393d3ad9313e213',
        voSpool: '0xaf56d16a7fe479f2fcd48ff567ff589cb2d2a0e9',
        voSpoolRewards: '0xb8d5fc11f8e1af30578db9f77174a1dc171a7d28',
        multicallv2: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
        feeHandler: '0x3d3d0a7876d18770a21a5ea05fef211eba808e72',
    },
};
